import { DownloadLicenseFile } from "./service"

const unitToDaysMap = {
  days: 1,
  seconds: 86400,
  microseconds: 8.64e+10
}

export function parseDurationVerbose(durationObject) {
  if (!durationObject) {
      return "Vitalícia"
  }
  var currentYear = new Date().getFullYear()
  var totalDays = Object.entries(durationObject).map(([key, value]) => {
      return Math.floor(value / unitToDaysMap[key])
  }).reduce(reducer)
  const yearDays = ((currentYear % 4 === 0) && ((currentYear % 100 !== 0) || (currentYear % 400 === 0))) ? 366 : 365
  var years = Math.floor(totalDays / yearDays)                    
  var yearString = (years === 0) ? null : `${years} ano${(years > 1) ? 's' : ''}`
  var days = (!!yearString) ? (totalDays - (years * yearDays)) : totalDays
  var daysString = (days === 0) ? null : `${days} dia${(days > 1) ? 's' : ''}`
  return [yearString, (!!yearString && !!daysString) ? `e` : null, daysString].filter(Boolean).join(" ")
}

const reducer = (previousValue, currentValue) => previousValue + currentValue

export function handleDownloadLicense (valueData) {
  console.log(valueData)
  DownloadLicenseFile(valueData.id).then((resp) => {
      var saveByteArray = (function () {
          var a = document.createElement("a");
          document.body.appendChild(a);
          return function (data, name) {
              var blob = new Blob([data], { type: resp.headers['content-type'] });
              var url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = name;
              a.click();
              window.URL.revokeObjectURL(url);
          };
      }());
      console.log(resp)
      saveByteArray(resp.data, `${valueData.hardware}_license.zip`);
  })
}